module.exports = __webpack_public_path__ + "img/assists.be6ab9bb.png";